import { SxProps, TextField, TextFieldProps, useTheme } from '@mui/material'
import { LOGIN_FONTS, getLoginPalette } from '../loginTheme'

const CustomTextField = (props: TextFieldProps) => {
    const theme = useTheme()
    const palette = getLoginPalette(theme.palette.mode === 'dark')

    const InputTextSxProps: SxProps = {
        width: '100%',
        maxWidth: '408px',

        '.MuiOutlinedInput-root': {
            height: '40px',
            borderRadius: '4px !important',
            backgroundColor: palette.surface,
            fontSize: '14px',
            color: palette.fg,
        },

        '.MuiOutlinedInput-root input': {
            height: '100%',
            fontFamily: `${LOGIN_FONTS.sans} !important`,
            '&::placeholder': {
                color: palette.mute,
                opacity: 1,
            },
        },

        '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderRadius: '4px !important',
            borderColor: palette.border,
        },

        '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.accent,
        },

        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.accent,
            borderWidth: '1px',
            boxShadow: `0 0 0 3px ${palette.accentSoft}`,
        },

        '.MuiFormHelperText-root': {
            marginLeft: 0,
        },

        '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
            WebkitBoxShadow: `0 0 0px 1000px ${palette.surface} inset !important`,
            WebkitTextFillColor: palette.fg,
            caretColor: palette.fg,
            transition: 'background-color 9999s ease-in-out 0s',
        },
    }

    return <TextField size={'medium'} {...props} sx={{ ...InputTextSxProps, ...props.sx }} />
}

export default CustomTextField
